import GeneralIedger from './GeneralIedger.vue'
export default GeneralIedger


// WEBPACK FOOTER //
// ./src/pages/GeneralIedger/index.js